import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {setupStore} from './redux/store/store';
import {StylesProvider} from '@material-ui/core';
import App from './app/App';
import DateFnsUtils from '@date-io/dayjs';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import {BrowserRouter} from 'react-router-dom';
import './i18n';
import {ErrorBoundary} from './shared';
import {PusherProvider} from "./context/pusherProvider";

const store = setupStore();

render(
    <Provider store={store}>
        <BrowserRouter >
            <StylesProvider injectFirst>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <ErrorBoundary>
                        <PusherProvider>
                            <App/>
                        </PusherProvider>
                    </ErrorBoundary>
                </MuiPickersUtilsProvider>
            </StylesProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
